import { ClaimModel } from '@ctw/shared/api/fhir/models/claim';
import type { PatientModel } from '@ctw/shared/api/fhir/models/patient';
import { fqsRequestAll, MAX_OBJECTS_PER_REQUEST } from '@ctw/shared/api/fqs/client';
import { type ClaimGraphqlResponse, claimsQuery } from '@ctw/shared/api/fqs/queries/claims';
import type { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import type { GraphQLClient } from 'graphql-request';

export async function fetchClaimsByIdFQS(
  telemetry: ReturnType<typeof useTelemetry>,
  graphqlClient: GraphQLClient,
  patient: PatientModel,
  ids: Array<string>,
) {
  const { data } = await fqsRequestAll<ClaimGraphqlResponse>(
    telemetry,
    graphqlClient,
    claimsQuery,
    'ClaimConnection',
    {
      upid: patient.UPID,
      cursor: '',
      first: MAX_OBJECTS_PER_REQUEST,
      sort: {},
      filter: {
        ids: {
          anymatch: ids,
        },
      },
    },
  );
  return data.ClaimConnection.edges.map(({ node }) => new ClaimModel(node));
}
